export const GIVEAWAY_END = new Date("2027-01-31T23:59:59+01:00");
export const giveawayLive = () => new Date() <= GIVEAWAY_END;
